import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";

export class LoopHandling extends BaseComponent {
    /**
     * Global exception handling
     * @module LoopHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            inARow: '',
            xAndOut: ''
        }
    }

    componentDidMount(){
        this.updateUIState();
    }

    setConfig(key, value){
        window.apm.serialized.globalLoopHandling[key] = value;
        window.apm.serialized.globalLoopHandling.lastLocalChange = window.apm.timestamp;
        this.updateUIState();
        window.apm.setSerializedChanged();
    }

    /**
     * Control the UI (dropdowns) via state
     */
     updateUIState(){
        this.setState({inARow: this.getConfig("inARow")});
        this.setState({xAndOut: this.getConfig("xAndOut")});
    }

    // TODO: update the Dropdowns used in this component
    // see DEVDES2-1562
    UNSAFE_componentWillReceiveProps(){
        this.updateUIState();
    }

    getConfig(key){
        return window.apm.serialized.globalLoopHandling[key];
    }

    moduleOptions(){
        const modules = window.apm.knowledgeBase.getModules();
        
        return modules.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    render(){
       
        const inARowSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.inARow, this.moduleOptions());
        const xAndOutSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.xAndOut, this.moduleOptions());
        
        return (
            <div className="row">
                <div className="col-md-6">
                    <Dropdown 
                        context={this} 
                        label="Module for In-A-Row Handling" 
                        tooltip={`Select a module to respond to callers when they repeat the same intent consecutively for a defined number of items.
                            This value is set by the In-a-Row Count setting in the Intent Handling section.`
                        }
                        optionName={window.l.settings.select_module}
                        options={this.moduleOptions()} 
                        valKey={"inARow"} 
                        selection={inARowSelected} 
                        removable={true} />
                </div>
                <div className="col-md-6">
                    <Dropdown 
                        context={this} 
                        label="Module for X-And-Out Handling" 
                        tooltip={`Select a module to respond to callers when the caller says the same statement several times during the call,
                            but the statements are not consecutive. The threshold for this module is set by the X-and-Out Count setting in the Intent Handling section.`
                        }
                        optionName={window.l.settings.select_module}
                        options={this.moduleOptions()} 
                        valKey={"xAndOut"} 
                        selection={xAndOutSelected} 
                        removable={true} />
                </div>
            </div>
        );
    }
}